export default __webpack_public_path__ + "static/media/5_Still.c8907ac0.jpg";